import { useQuery } from "@tanstack/react-query";
import { CategoryFragment } from "./fragments/category";
import { GetActiveMenuCategoriesDocument } from "~/types/__generated/gql/graphql";
import { gqlReq } from "~/libs/gql";
import { useLocationId } from "~/store";

void (
	/* GraphQL */ `
		query GetActiveMenuCategories {
			getActiveMenuCategories {
				...CategoryFragment
			}
		}
		${CategoryFragment}
	`
);

export const getActiveMenuCategoriesQueryKey = () => [
	"getActiveMenuCategories",
];

export const useGetActiveMenuCategories = () => {
	const locationId = useLocationId();

	return useQuery({
		enabled: !!locationId,
		queryKey: getActiveMenuCategoriesQueryKey(),
		queryFn: ({ signal }) =>
			gqlReq({
				document: GetActiveMenuCategoriesDocument,
				signal,
			}),
	});
};
